import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppTokenService {
  readonly DEFAULT_SITE_SETTING_NAME = 'default-site-setting';
  readonly DEFAULT_PAGE_CATEGORY_NAME = 'default-page-category';
  readonly DEFAULT_MENU_NAME = 'default-menu';
  static readonly SITE_SETTING_SCHEMA_NAME = 'sitesetting';
  static readonly PAGE_CATEGORY_SCHEMA_NAME = 'page-category';
  static readonly MENU_SCHEMA_NAME = 'menu';
  static readonly MENU_ITEM_SCHEMA_NAME = 'menu-item';
  static readonly PAGE_SCHEMA_NAME = 'page';
  static readonly CLAIM_SCHEMA_NAME = 'claim';
  readonly USER_SAVE_CULTURE_CODE: string = 'USER_SAVE_CULTURE_CODE';
  readonly ENGLISH_CULTURE_CODE: string = 'en-CA';
  readonly FRENCH_CULTURE_CODE: string = 'fr-CA';
  readonly INPUT_DELAY_TIMESPAN: number = 600;
}
